module.exports = __webpack_public_path__ + "static/media/pres54.21789a51.png";